export default "__VITE_ASSET__D4f2KfM2__"